<template>
  <modal transition="pop-out" name="update-sub-category" :height="500">
    <div class="h-10 w-full border-b border-gray-200">
      <p class="px-8 py-2 text-gray-700 font-bold">Edit Sub Category</p>
    </div>
    <div class="w-full">
      <form class="rounded px-8 pt-6 pb-8 mb-4" @submit.prevent>
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Name
          </label>
          <input v-model="form.name" class="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="text" placeholder="Category Name">
          <p v-if="errors.includes('name')" class="text-red-500 text-xs italic">Please provide a name.</p>
        </div>
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Category
          </label>
          <el-select :disabled="disabled" v-model="form.category_id" placeholder="Select">
            <el-option
              v-for="item in categories"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <p v-if="errors.includes('category_id')" class="text-red-500 text-xs italic">Please provide a category.</p>
        </div>
        <div class="mb-2">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Description
          </label>
          <textarea v-model="form.description" class="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="text" placeholder="Description...."></textarea>
          <p v-if="errors.includes('description')" class="text-red-500 text-xs italic">Please provide some description.</p>
        </div>
        <div class="mb-6">
          <el-upload
            :action="upload_url"
            accept="image/jpeg, image.png">
            <el-button size="small">Choose sub-category image</el-button>
          </el-upload>
        </div>
        <div class="flex items-center justify-between">
          <el-button @click="submit" type="primary" :loading="updating">Update</el-button>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
import { cloneDeep } from 'lodash';

export default {
  name: 'UpdateForm',
  props: {
    upload_url: {
      type: String,
    },
  },
  data() {
    return {
      updating: false,
      disabled: false,
      update_image: false,
      errors: [],
    };
  },
  computed: {
    form() {
      const data = cloneDeep(this.$store.state.InventoryModule.Catalog.currentSelected.subCategory);
      if (this.$route.name === 'subcategory') {
        data.category_id = parseInt(this.$route.params.id, 10);
      }

      return data;
    },
    categories() {
      return this.$store.getters['InventoryModule/Catalog/getCategoryForSelect'];
    },
  },
  methods: {
    async submit() {
      this.errors = [];
      // formValidation is a mixin in
      // src/Common/mixins/index.js
      this.errors = this.formValidation(this.form);

      // check for error length
      if (this.errors.length === 0) {
        try {
          this.updating = true;

          const subCategoryId = this.form.id;
          this.form = {
            name: this.form.name,
            description: this.form.description,
            homepage_feature: this.form.homepage_feature,
            category_id: this.form.category_id,
          };
          await this.$store.dispatch('InventoryModule/Catalog/updateSubCategory', {
            data: this.form,
            subCategoryId,
            category: this.getSelectedCategory(),
          });

          this.$modal.hide('update-sub-category');
          this.$notify.success({
            title: 'Success',
            message: 'SubCategory successfully updated',
          });
        } catch (e) {
          this.updating = false;
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong',
          });
        }

        this.updating = false;
      }
    },
    getSelectedCategory() {
      return this.categories.filter(item => item.value === this.form.category_id);
    },
  },
  mounted() {
    this.disabled = this.$route.name === 'subcategory';
  },
};
</script>

<style scoped>

</style>
